import { useMemo } from 'react';

import { sortTheEs } from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence.utils';
import type { GetLessonTeachingAndLearningSequenceQuery } from './teaching-notes.graphql.generated';
import TeachingNotesMetaDataItem from './teaching-notes-meta-data-item';
import type { Pluck } from 'lib/gql/pluck';

const TeachingNotesTheEs = ({
  theEsDetails,
  displayExpanded,
}: {
  theEsDetails: Pluck<
    GetLessonTeachingAndLearningSequenceQuery,
    'getLessonTeachingAndLearningSequence.theEsDetails'
  >[];
  displayExpanded?: boolean;
}) => {
  const sortedEs = useMemo(() => sortTheEs(theEsDetails), [theEsDetails]);

  return (
    <TeachingNotesMetaDataItem
      title="5e Pedagogical Model"
      items={sortedEs}
      displayExpanded={displayExpanded}
    />
  );
};

export default TeachingNotesTheEs;
